import ColorsStyles from '@Styles/colors.scss';
import {
    LoadingButton as MuiLoadingButton,
    LoadingButtonProps as MuiLoadingButtonProps,
} from '@mui/lab';
import { styled } from '@mui/material';
import React from 'react';
import { getBtnColor } from '@Components/Button/Button';

const BaseLoadingButton = styled(MuiLoadingButton)`
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 0.02em;
    line-height: 17px;
    padding: 4px 10px;

    &:disabled {
        background-color: ${ColorsStyles.ikeGradient9};
        color: #fff;
    }
`;

interface ILoadingButtonProps extends Omit<MuiLoadingButtonProps, 'color'> {
    color: string;
}

const LoadingButton = (props: ILoadingButtonProps) => {
    const { color, ...loadingBtnProps } = props;

    return (
        <BaseLoadingButton
            {...loadingBtnProps}
            sx={{
                backgroundColor: getBtnColor(color),
                color: '#fff',
                '&:hover': {
                    backgroundColor: getBtnColor(color, true),
                },
            }}
        />
    );
};

export default LoadingButton;
